import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';
// Actions
export const INIT_SINGLE_PAGE_CHECKOUT_PAGE = 'INIT_SINGLE_PAGE_CHECKOUT_PAGE';
export const INIT_EDD = 'INIT_EDD';
export const SAVE_AND_CONTINUE_SHIPPING = 'SAVE_AND_CONTINUE_SHIPPING';
export const CLICKED_OUTSIDE_SHIPPING = 'CLICKED_OUTSIDE_SHIPPING';
export const SAVE_AND_CONTINUE_PICKUP = 'SAVE_AND_CONTINUE_PICKUP';
export const SAVE_ADDRESS_FROM_MELISSA = 'SAVE_ADDRESS_FROM_MELISSA';
export const SAVE_AND_CONTINUE_PAYMENT = 'SAVE_AND_CONTINUE_PAYMENT';
export const SUBMIT_ORDER_WITH_PAYMENT = 'SUBMIT_ORDER_WITH_PAYMENT';
export const TOGGLE_SPC = 'TOGGLE_SPC';
export const RECALIBRATE_SECTIONS_STATES = 'RECALIBRATE_SECTIONS_STATES';
export const SET_CVV_MODULE_X = 'SET_CVV_MODULE_X';
export const FETCH_CVV_MODULE_X = 'FETCH_CVV_MODULE_X';
export const SET_GIFT_DETAIL_MODAL_MODULE_X = 'SET_GIFT_DETAIL_MODAL_MODULE_X';
export const FETCH_GIFT_DETAIL_MODAL_MODULE_X = 'FETCH_GIFT_DETAIL_MODAL_MODULE_X';
export const SET_CVV_VISIBILITY_ON_VIEW_MODE = 'SET_CVV_VISIBILITY_ON_VIEW_MODE';
export const SET_SPC_BTN_LOADER = 'SET_SPC_BTN_LOADER';
export const SAVE_SPC_CONTACT = 'SAVE_SPC_CONTACT';
export const ACTIVATE_SPC_SECTION = 'ACTIVATE_SPC_SECTION';
export const RESET_SPC_UI_STATE = 'RESET_SPC_UI_STATE';
export const SET_SECTION_ANCHORING = 'SET_SECTION_ANCHORING';
export const PAYMENT_METHOD_VENMO = 'VENMO';
export const SHOW_ADDRESS_VERIFICATION = 'SHOW_ADDRESS_VERIFICATION';
export const ADD_EDIT_STORE_DETAILS = 'ADD_EDIT_STORE_DETAILS';
export const SET_SFS_ERROR = 'SET_SFS_ERROR';
export const ADD_SFS_ITEMS_TO_SFL = 'ADD_SFS_ITEMS_TO_SFL';
export const MOVE_ITEM_TO_SFL_TOGGLE = 'MOVE_ITEM_TO_SFL_TOGGLE';
export const REMOVE_ITEM_IN_PROGRESS = 'REMOVE_ITEM_IN_PROGRESS';
export const IS_EXPRESS_CALL_DONE = 'IS_EXPRESS_CALL_DONE';
export const IS_NON_CACHED_CART_DATA_CALL_DONE = 'IS_NON_CACHED_CART_DATA_CALL_DONE';
export const TRIGGER_CHECKOUT_WITH_PAYMENT = 'TRIGGER_CHECKOUT_WITH_PAYMENT';
export const IS_EXTENDED_PRE_ORDER = 'IS_EXTENDED_PRE_ORDER';
export const SHOW_SHIPPING_METHODS_IN_COLLAPSED = 'SHOW_SHIPPING_METHODS_IN_COLLAPSED';
export const TOGGLE_VERIFY_CVV_MODAL = 'TOGGLE_VERIFY_CVV_MODAL';
export const SHOULD_SHOW_VERIFY_CVV_MODAL = 'SHOULD_SHOW_VERIFY_CVV_MODAL';
export const SET_SUPPRESS_CCHECK = 'SET_SUPPRESS_CCHECK';
export const SET_IS_OOS_ITEM = 'SET_IS_OOS_ITEM';

export const SPC_BUTTON = {
  SAVE_CONTACT: 'saveContactBtn',
  SAVE_SHIPPING: 'saveShippingBtn',
  SAVE_PICKUP: 'savePickupBtn',
  SAVE_PAYMENT: 'savePaymentBtn',
  APPLY_GIFT_CARD: 'applyGiftCardBtn',
  SUBMIT_ORDER: 'submitOrderBtn',
};

export const PAYMENT_METHOD_CREDIT_CARD = 'creditCard';
export const PAYMENT_METHOD_AFTERPAY = 'AFTERPAY';

export const SPC_SECTION = {
  MY_BAG: 'myBagSection',
  MY_BAG_WITH_EDD: 'myBagWithEddSection',
  CONTACT: 'contactSection',
  SHIPPING: 'shippingSection',
  PICKUP: 'pickupSection',
  PAYMENT: 'paymentSection',
  REWARDS_AND_OFFERS: 'rewardsAndOffers',
  ORDER_SUMMARY: 'orderSummary',
};
export const SET_APPLE_WALLET = 'SET_APPLE_WALLET';
export const UPDATE_SECTION_STATE = 'UPDATE_SECTION_STATE';
export const UPDATE_MULTIPLE_SECTION_STATES = 'UPDATE_MULTIPLE_SECTION_STATES';

export const SECTION_MODE = {
  SECTION_ADD_MODE: 'SECTION_ADD_MODE',
  SECTION_EDIT_MODE: 'SECTION_EDIT_MODE',
  SECTION_VIEW_MODE: 'SECTION_VIEW_MODE',
};

export const CARD_TYPES = {
  CREDIT_CARD: 'CREDIT_CARD',
  PLCC_CARD: 'PLACE CARD',
  PLACECARD: 'PLACECARD',
  AFTERPAY: 'AFTERPAY',
  VENMO: 'VENMO',
};

export const CARD_IMAGES = [
  { key: 'amex', src: 'amex-small', alt: 'americanExpressCard' },
  { key: 'visa', src: 'visa-small', alt: 'visaCard' },
  { key: 'mc', src: 'mc-small', alt: 'masterCard' },
  { key: 'disc', src: 'discover-card', alt: 'discoverCard' },
  { key: 'PLACE CARD', src: 'place-card-small', alt: 'placeCard' },
  { key: 'PLACE CARD_PJP', src: 'place-card-pjp-small', alt: 'placeCard' },
];

// It is being used in SFCC OC API
export const CARD_NAME_MAPPING = {
  AMEX: 'Amex',
  DISC: 'Discover',
  MC: 'Master Card',
  VISA: 'Visa',
};

export const ALL_PAYMENT_TYPE_IMAGES = [
  ...CARD_IMAGES,
  { key: 'PAYPAL', src: 'paypal-icon', alt: 'paypal-icon' },
];

export const getTermsLink = {
  activeLink: '/help-center/terms-conditions#termsandconditions',
  activeHref: '/help-center?pageName=terms-conditions#termsandconditions',
};

export const getPrivacyLink = {
  activeLink: '/help-center/policies#privacypolicy',
  activeHref: '/help-center?pageName=policies#privacypolicy',
};

export const DEFAULT_ADDRESS_ID = 'me';

export const ADDRESS_FORM_MODE = {
  HIDDEN: 'HIDDEN',
  ADD_NEW: 'ADD_NEW',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  SELECT_FROM_ADDRESS_BOOK: 'SELECT_FROM_ADDRESS_BOOK',
  ADD_ADDRESS_TO_ADDRESS_BOOK: 'ADD_ADDRESS_TO_ADDRESS_BOOK',
  EDIT_ADDRESS_FROM_ADDRESS_BOOK: 'EDIT_ADDRESS_FROM_ADDRESS_BOOK',
};

export const ADDRESS_TYPE = {
  BILLING: 'billing',
  SHIPPING: 'shipping',
  SHIPPING_AND_BILLING: 'ShippingAndBilling',
};

export const ACCORDION_REF = {
  CONTACT_REF_ID: 'contactRefId',
  SHIPPING_REF_ID: 'shippingRefId',
  PICKUP_REF_ID: 'pickupRefId',
  PAYMENT_REF_ID: 'paymentRefId',
};

export const HEADER_OFFSET = {
  MOBILE: 70,
  TABLET: 70,
  DESKTOP: 70,
};

// Anchoring delay for different sections
export const SCROLL_ACCORDION_DELAY = {
  [ACCORDION_REF.CONTACT_REF_ID]: 1000,
  [ACCORDION_REF.SHIPPING_REF_ID]: 1000,
  [ACCORDION_REF.PAYMENT_REF_ID]: 1000,
};

export const SCROLL_ACCORDION_OPTIONS = {
  behavior: 'smooth',
};

export const ORDER_SUMMARY_VISIBILITY_OFFSET = 150;

export const ORDER_SUMMARY_WRAPPER_CLASSNAME = 'spc-content-wrapper';
export const ORDER_SUMMARY_WIDTH_RATIO = 570 / 1410;
export const SPC_PAY_PAL_BUTTON_HEIGHT = 51;
export const SHIPMENT_ID = 'me';

export const SPC_CAROUSEL_ARROW = 'carousel-big-carrot';

export const SPC_CAROUSEL_OPTIONS = {
  options: {
    accessibility: false,
    autoplay: false,
    arrows: true,
    centerMode: false,
    infinite: false,
    centerPadding: '0px',
    fade: false,
    speed: 200,
    swipeToSlide: false,
    lazyLoad: false,
    dots: false,
    swipe: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: parseInt(breakpoints.xlarge, 10) - 1,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: parseInt(breakpoints.large, 10) - 1,
        settings: {
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  },
  carouselConfig: {},
  isModule: true,
  className: 'full-bleed',
};

export const SUBMIT_ORDER_BUTTON_STATE = {
  NORMAL: 'NORMAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
};

export const PAYMENT_FORM_ERROR = getDynamicLabelValues(
  `dynamic.error_messages.lbl_payment_form_error`
);

export const UPDATE_SUBMIT_ORDER_BUTTON_STATE = 'UPDATE_SUBMIT_ORDER_BUTTON_STATE';
export const SUBMIT_ORDER_CONTAINER_ID = 'submit-order-container';

export const STICKY_ORDER_SUMMARY = {
  INTERSECTING_DIV_STYLE: {
    height: '1px',
  },
  INTERSECTION_OBSERVER_CONFIG: {
    LEFT_TOP_DIV: {
      root: null,
      rootMargin: '-60px 0px 0px 0px',
      threshold: 1.0,
    },
    RIGHT_BOTTOM_DIV: { root: null, rootMargin: '0px' },
    SUBMIT_ORDER_BUTTON: {
      root: null,
      rootMargin: '-60px 0px 0px 0px',
      threshold: 1.0,
    },
  },
};

export const GIFT_CARD_FOCUS_TIMEOUT = 3000;
